<template>
    <div>
        <b-button class="mb-3 right" variant="primary" @click="isModalOpen=true">
            Kostennote hinzufügen
        </b-button>

        <div class="clear"/>

        <b-modal v-model="isModalOpen" hide-footer no-close-on-backdrop size="xl"
            title="Kostennote hinzufügen" @hide="reset()" @show="loadForm">
            <div class="record-fee-create-modal">
                <csp-desktop-info-card
                    :cols="12"
                    :form-context="formContext"
                    icon="inticon-users"
                    title="Kostennote"
                    @cancel-form="reset"
                    @save="saveCostUnitFormData">
                    <csp-record-detail-fee-create-basedata
                        :form-context="formContext"/>
                </csp-desktop-info-card>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import FeeCreateBasedata from '@desktop/components/record/fee/RecordFeeCreateBasedata.vue';
    import Container from '@services/Container';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'FeeCreateModal',
        components: {
            'csp-record-detail-fee-create-basedata': FeeCreateBasedata,
        },
        mixins: [FormDataMixin],
        props: {
            recordId: {
                type: Number,
                required: true,
            },
        },
        emits: ['created'],
        data() {
            return {
                isModalOpen: false,
            }
        },
        methods: {
            loadForm() {
                const loadFunction = () => {
                    return recordRepository.loadFeeCreationForm(this.recordId);
                };
                this.loadFormData(loadFunction).finally(() => {
                    this.isLoading = false;
                });
            },
            reset() {
                this.formContext.form.reset();
                this.isModalOpen = false;
            },
            saveCostUnitFormData(formContext) {
                const saveFunction = (objectId, postData) => {
                    return recordRepository.saveFeeNew(this.recordId, postData);
                };
                this.saveFormData(formContext, saveFunction, false).then(() => {
                    this.$emit('created');
                    this.reset();
                });
            },
        },
    }
</script>
